import CertsListBody from './CertsListBody';

export default CertsListBody;
